import React from 'react';
import { Tab } from 'semantic-ui-react';

import './technos.scss';

import General from './General';
import FrontEnd from './FrontEnd';
import BackEnd from './BackEnd';

const Technos = () => {

  const panes = [
    {
      menuItem: 'General',
      render: () => (
        <Tab.Pane attached={false}>
          <General />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Front-end',
      render: () => (
        <Tab.Pane attached={false}>
          <FrontEnd />
        </Tab.Pane>
      ),
    },
    {
      menuItem: 'Back-end',
      render: () => (
        <Tab.Pane attached={false}>
          <BackEnd />
        </Tab.Pane>
      ),
    },
  ]
  
  return (
    
    <div id="technos">
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
    
  );  
  
};

Technos.propTypes = {
};

export default Technos;
